import { Component, Input, OnChanges, } from '@angular/core';
import { ExtractedMultipleShowcase, SHOWCASES_PARAMS, ShowcasesEntity, ShowcasesTypes, } from 'search/full-card/models/showcases';
import { EntityTypes } from '../../../../../../entity/models/entity';

@Component({
  selector: 'app-multiple-showcases-view',
  templateUrl: './multiple-showcases-view.component.html',
  styleUrls: ['./multiple-showcases-view.component.scss'],
})
export class MultipleShowcasesViewComponent implements OnChanges {
  @Input() public showcases: ExtractedMultipleShowcase[];
  @Input() public totalCount: number;
  @Input() public entity: ShowcasesEntity;
  @Input() public showcaseId: string;
  @Input() public showcaseType: ShowcasesTypes;
  public CONCEPT = EntityTypes.CONCEPT;
  public showcasesTypes = ShowcasesTypes;
  public isSeeAllButtonVisible: boolean;
  public title: string;

  public ngOnChanges() {
    this.isSeeAllButtonVisible = ((this.entity.entityType === EntityTypes.INSTANCE || this.entity.entityType === EntityTypes.FORMAT_GROUP)
      && this.totalCount > SHOWCASES_PARAMS.TOPICS_PER_SHOWCASE_RESOURCE_PAGE)
      || this.totalCount > SHOWCASES_PARAMS.TOPICS_PER_SHOWCASE_PAGE;
  }
}
